import useGetBasicFilters from "src/aadeCase/hooks/useGetBasicFilters";
import { TCaseFilter } from "../data-access/types";
import useGetOrganizations from "src/aadeCase/data-access/useGetOrganizations";
import { useTranslation } from "react-i18next";

export default function useGetAdminBasicFilters() {
  const filters = useGetBasicFilters();

  const { data: organizationResponse, isLoading: isLoadingOrganizations } =
    useGetOrganizations();

  const { t } = useTranslation();

  const adminFilters: TCaseFilter[] = [
    ...filters,
    {
      label: t("Επιμελητήριο"),
      component: {
        type: "autoComplete" as const,
        options: organizationResponse?.data?.chamberList,
        loading: isLoadingOrganizations,
      },
      name: "chamber",
    },
  ];

  return adminFilters;
}
